export function supportsContainerQueries() {
  return CSS.supports('container-type', 'inline-size');
}
